import { css } from "@emotion/react";
import { Theme } from "@mui/material/styles/createTheme";

export const accessibeTriggerContainerStyles = {
  accessibeTrigger: (theme: Theme) =>
    css({
      "&:hover": { backgroundColor: theme.palette.secondary.dark },
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
      padding: 4,
    }),
  accessibeTriggerContainer: (
    searchOpen?: boolean,
    isAuthenticated?: boolean
  ) =>
    css({
      paddingLeft: searchOpen ? 16 : 8,
      paddingRight: isAuthenticated ? 8 : 16,
    }),
};
